import clsx from 'clsx';
import React, {} from 'react';
export const Image = ({ alt, 'aria-label': ariaLabel, className, src, style }) => (React.createElement("img", { alt: alt, "aria-label": ariaLabel ?? alt, className: clsx('block max-w-full', className), src: src, style: style }));
